'use strict';

const React = require('react');

const PropTypes = require('prop-types');

const CloseIcon = require('dibs-vg/dist/react/close');
const ShareIcon = require('dibs-vg/dist/react/share');
const BackIcon = require('dibs-vg/dist/react/arrow-left');
const InfoIcon = require('dibs-vg/dist/react/info-circle');
const GalleryPhotoSocial = require('./GalleryPhotoSocial');

const classNames = require('classnames');

function GalleryMobileNavWrapper({ styles, isModal, showSocial, showDetails, actions }) {
    const DetailsIcon = showDetails ? BackIcon : InfoIcon;

    const className = classNames(styles.wrapper, {
        [styles.showSocial]: showSocial,
        [styles.showDetails]: showDetails,
    });

    return (
        <div className={className}>
            {/* DETAILS / INFO */}
            <div
                className={classNames(styles.details, styles.button, styles.leftButton)}
                onClick={actions.toggleDetails}
            >
                <div>
                    <DetailsIcon className={styles.icon} />
                    <p className={styles.text}>{showDetails ? 'BACK' : 'DETAILS'}</p>
                </div>
            </div>

            {/* SHARE */}
            <div
                className={classNames(styles.share, styles.button, styles.leftButton)}
                onClick={actions.toggleSocial}
            >
                <div>
                    <ShareIcon className={styles.icon} />
                    <p className={styles.text}>SHARE</p>
                </div>
            </div>

            {/* SOCIAL */}
            <div className={classNames(styles.social, styles.middleSection)}>
                <GalleryPhotoSocial
                    classes={{ wrapper: styles.socialIcons, icon: styles.socialIcon }}
                    sharePhoto={actions.sharePhoto}
                />
            </div>

            {/* CLOSE */}
            {isModal ? (
                <div
                    className={classNames(styles.close, styles.button, styles.rightButton)}
                    onClick={actions.hideModal}
                >
                    <CloseIcon className={styles.icon} />
                </div>
            ) : null}
        </div>
    );
}

GalleryMobileNavWrapper.propTypes = {
    isModal: PropTypes.bool.isRequired,
    showSocial: PropTypes.bool.isRequired,
    showDetails: PropTypes.bool.isRequired,

    actions: PropTypes.shape({
        hideModal: PropTypes.func.isRequired,
        sharePhoto: PropTypes.func.isRequired,
        toggleSocial: PropTypes.func.isRequired,
        toggleDetails: PropTypes.func.isRequired,
    }).isRequired,
    styles: PropTypes.shape({
        showSocial: PropTypes.string,
        showDetails: PropTypes.string,

        wrapper: PropTypes.string,
        details: PropTypes.string,
        share: PropTypes.string,
        social: PropTypes.string,
        close: PropTypes.string,
        socialIcons: PropTypes.string,
        socialIcon: PropTypes.string,

        icon: PropTypes.string,
        text: PropTypes.string,
        button: PropTypes.string,
        leftButton: PropTypes.string,
        rightButton: PropTypes.string,
        middleSection: PropTypes.string,
    }).isRequired,
};

GalleryMobileNavWrapper.defaultProps = {
    styles: require('./GalleryMobileNavWrapper-style.scss'),
};

module.exports = GalleryMobileNavWrapper;



// WEBPACK FOOTER //
// ./assets/js/gallery/components/GalleryMobileNavWrapper.jsx